import sectionTextSurveyCss from '../css-snippets/section-text-survey';
const html = `
<style>${sectionTextSurveyCss}</style>
<div data-attribute="card-container" data-top-padding="true" data-bottom-padding="true">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF" style="background-color: transparent;">
     <div class="wrap-card container">
        <div data-attribute="card-left" data-order="1" class="card-left" style="order: 1;">
           <div data-attribute="card-title" class="wrap-text">
              <h2 style="text-align:center;">Proven Results, Happy Parents, Happier Kids📊</h2>
           </div>
        </div>
        <div data-attribute="card-right" data-order="2" class="card-right" data-style-center-y="false" style="order: 2;">
           <div data-attribute="card-content" class="card-content">
              <div data-attribute="card-survay" data-color-percent="#17d4f4" data-show-survay="true" class="card-survay" style="display: block;">
                 <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item">
                       <svg class="size-full" viewBox="0 0 100 100">
                          <circle class="text-gray-300" stroke-width="8" stroke="#ffffff" fill="transparent" cx="50" cy="50" r="40"></circle>
                          <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="#17d4f4" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="251.32741228718345" stroke-dashoffset="22.619467105846503"></circle>
                       </svg>
                       <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: #17d4f4;"><span data-attribute="percent-survay">91</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                       shared that our robot helped their children build patience and focus.
                    </div>
                 </div>
                 <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item">
                       <svg class="size-full" viewBox="0 0 100 100">
                          <circle class="text-gray-300" stroke-width="8" stroke="#ffffff" fill="transparent" cx="50" cy="50" r="40"></circle>
                          <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="#17d4f4" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="251.32741228718345" stroke-dashoffset="22.619467105846503"></circle>
                       </svg>
                       <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: #17d4f4;"><span data-attribute="percent-survay">91</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                       noticed better handwriting and improved drawing skills.
                    </div>
                 </div>
                 <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item">
                       <svg class="size-full" viewBox="0 0 100 100">
                          <circle class="text-gray-300" stroke-width="8" stroke="#ffffff" fill="transparent" cx="50" cy="50" r="40"></circle>
                          <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="#17d4f4" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="251.32741228718345" stroke-dashoffset="22.619467105846503"></circle>
                       </svg>
                       <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: #17d4f4;"><span data-attribute="percent-survay">91</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                       of parents shared their kids now spend more time creating and less time on screens.
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</div>
`;
export default html;
